// 快訊列表內 一則快訊
import dayjs from 'dayjs';
import Link from 'next/link';
import Image from 'next/image';

const FlashComponent = ({ flash, isLast }) => {
    const publishedTime = dayjs(flash?.publishedTime).format('HH:mm');

    return (
        <div className="w-full group [&>*]:flex">
            {/* 快訊時間 */}
            <p className="items-center text-bd1b text-black gap-x-[12px]">
                <span className="trans w-[12px] h-[12px] rounded-[50%] border-1 border-pale9 group-hover:bg-pale9" />
                {publishedTime}
            </p>

            <div className="gap-x-[19px]">
                {/* 虛線 */}
                <div
                    className={`flex-shrink-0 w-[2px] border-l-1 border-dashed border-l-black3 ml-[5px] ${
                        isLast ? 'opacity-0' : ''
                    }`}
                >
                    &nbsp;
                </div>

                {/* 快訊內容 */}
                <div className="flex-grow pb-[60px]">
                    <Link
                        href={`/flash/${flash?.id}`}
                        className={`block trans border-1 rounded-[4px] p-[30px] w-full space-y-[12px] usm:p-[25px]
            ${
                flash?.appPush === 1
                    ? 'bg-opacity-[0.1] border-opacity-[0.1] bg-[#29afcb] border-[#29afcb] group-hover:border-opacity-[1]'
                    : 'border-black1  bg-white group-hover:border-black2 group-hover:bg-black1'
            }`}
                    >
                        {/* 快訊標題 */}
                        <div className="flex items-start gap-x-[12px]">
                            {flash?.appPush === 1 && (
                                <div className="h-[32px] flex items-center">
                                    <div className="img-box w-[24px] h-[24px] after:content-[none]">
                                        <Image
                                            src="/images/icon/icon_flash.svg"
                                            alt="flash"
                                            width={24}
                                            height={24}
                                            loading="lazy"
                                        />
                                    </div>
                                </div>
                            )}
                            <h2
                                className={`text-bd1b hover-text ${
                                    flash?.appPush === 1
                                        ? 'text-pale group-hover:!decoration-pale dark:group-hover:!decoration-dpale'
                                        : 'text-black '
                                }`}
                            >
                                {flash?.title}
                            </h2>
                        </div>

                        {/* 內文摘要 */}
                        <p
                            className="line-clamp-2 text-bd1m text-black9"
                            dangerouslySetInnerHTML={{
                                __html: flash?.brief,
                            }}
                        />

                        <span className="text-btn1 text-pale inline-block mt-[12px]">
                            [查看更多]
                        </span>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default FlashComponent;
